<script setup lang="ts">
</script>
<template>
  <div class="tw-h-full tw-flex tw-flex-col tw-items-center tw-space-y-4 tw-w-full tw-flex-grow-1">
    <div class="tw-relative tw-aspect-[1/1] tw-h-full tw-rounded-full tw-bg-connx-grey-tint-75 tw-animate-pulse-slow">
      <div class="tw-absolute tw-inset-10 tw-rounded-full tw-bg-connx-grey-tint-85"></div>
    </div>

    <div class="tw-flex tw-gap-2 tw-w-full tw-max-w-xs">
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-w-4 tw-h-4 tw-rounded-full tw-bg-connx-grey-tint-75 tw-animate-pulse-slow"></div>
        <div class="tw-h-3 tw-w-20 tw-bg-connx-grey-tint-75 tw-rounded tw-animate-pulse-slow"></div>
      </div>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-w-4 tw-h-4 tw-rounded-full tw-bg-connx-grey-tint-60 tw-animate-pulse-slow"></div>
        <div class="tw-h-3 tw-w-16 tw-bg-connx-grey-tint-75 tw-rounded tw-animate-pulse-slow"></div>
      </div>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-w-4 tw-h-4 tw-rounded-full tw-bg-connx-grey-tint-70 tw-animate-pulse-slow"></div>
        <div class="tw-h-3 tw-w-14 tw-bg-connx-grey-tint-75 tw-rounded tw-animate-pulse-slow"></div>
      </div>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-w-4 tw-h-4 tw-rounded-full tw-bg-connx-grey-tint-80 tw-animate-pulse-slow"></div>
        <div class="tw-h-3 tw-w-12 tw-bg-connx-grey-tint-75 tw-rounded tw-animate-pulse-slow"></div>
      </div>
    </div>
  </div>

</template>